(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[499,5442],{

/***/ 59848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = undefined;

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Container, _React$Component);

  function Container() {
    (0, _classCallCheck3.default)(this, Container);
    return (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  (0, _createClass3.default)(Container, [{
    key: 'getClassName',
    value: function getClassName() {
      var className = ['os_container'];
      className.push('os_container_' + this.props.size);
      if (this.props.className) {
        className.push(this.props.className);
      }

      return className.join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.getClassName(), style: this.props.style },
        this.props.children
      );
    }
  }]);
  return Container;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.any,
  style: _propTypes2.default.object,
  size: _propTypes2.default.string,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  size: 'big',
  style: {},
  className: ''
}, _temp);
exports.Z = Container;

/***/ }),

/***/ 88572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "boundClass": function() { return /* binding */ boundClass; },
/* harmony export */   "boundMethod": function() { return /* binding */ boundMethod; },
/* harmony export */   "default": function() { return /* binding */ autobind; }
/* harmony export */ });
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(_typeof(fn)));
  } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.


  var definingProperty = false;
  return {
    configurable: true,
    get: function get() {
      // eslint-disable-next-line no-prototype-builtins
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== 'function') {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get: function get() {
          return boundFn;
        },
        set: function set(value) {
          fn = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set: function set(value) {
      fn = value;
    }
  };
}
/**
 * Use boundMethod to bind all methods on the target.prototype
 */

function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys; // Use Reflect if exists

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype); // Use symbols if support is provided

    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}
function autobind() {
  if (arguments.length === 1) {
    return boundClass.apply(void 0, arguments);
  }

  return boundMethod.apply(void 0, arguments);
}

/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 40098:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 47445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(40098),
    isIterateeCall = __webpack_require__(16612),
    toFinite = __webpack_require__(18601);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 96026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(47445);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 65530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/complaints",
      function () {
        return __webpack_require__(12310);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79961);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




function Loading(props) {
    var color = props.color, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().item), className),
            style: {
                borderColor: color
            }
        })
    });
};


/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 72700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AbstractLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97165);




var Website = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(1470), __webpack_require__.e(9659), __webpack_require__.e(8907), __webpack_require__.e(6700)]).then(__webpack_require__.bind(__webpack_require__, 38907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38907)
            ];
        }
    }
});
var Clean = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 5173).then(__webpack_require__.bind(__webpack_require__, 45173));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45173)
            ];
        }
    }
});
var NoWebsite = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 5442).then(__webpack_require__.bind(__webpack_require__, 25442));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25442)
            ];
        }
    }
});
var getLayout = function(theme) {
    var layouts = {
        website: Website,
        clean: Clean
    };
    return layouts[theme];
};
/**
 * @deprecated
 * If possible, avoid using this Layout component and use AbstractLayout instead (providing the LayoutComponent prop)
 * It provides faster development and build time.
 * Explanation: Webpack will precompile all nested imports (even for layouts that are not used by the current page).
 * By using AbstractLayout, we can make webpack only precompile the layout that is actually used by the current page.
 */ function Layout(props) {
    var _theme = props.theme, theme = _theme === void 0 ? "website" : _theme, initialData = props.initialData, _forceLightTheme = props.forceLightTheme, forceLightTheme = _forceLightTheme === void 0 ? false : _forceLightTheme, children = props.children;
    var Component = getLayout(theme);
    if (!initialData) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoWebsite, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AbstractLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        LayoutComponent: Component,
        initialData: initialData,
        forceLightTheme: forceLightTheme,
        children: children
    });
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 12310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ComplaintsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/SsgFallback/index.tsx
var SsgFallback = __webpack_require__(19060);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/AutoForm/index.tsx
var AutoForm = __webpack_require__(67605);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/fields/Money/index.tsx + 4 modules
var Money = __webpack_require__(94083);
// EXTERNAL MODULE: ./src/components/fields/Phone/index.tsx + 2 modules
var Phone = __webpack_require__(44682);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/fields/RadioComponents/styles.module.css
var styles_module = __webpack_require__(50672);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/fields/RadioComponents/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Component;
var RadioComponents = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(RadioComponents, _superClass);
    var _super = _createSuper(RadioComponents);
    function RadioComponents() {
        _classCallCheck(this, RadioComponents);
        return _super.apply(this, arguments);
    }
    var _proto = RadioComponents.prototype;
    _proto.renderOptions = function renderOptions() {
        var _this = this;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Readonl... Remove this comment to see the full error message
        return this.props.options.map(function(option, index) {
            var _this1 = _this;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
            var selected = _this.props.value === option.value;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
            var onClick = function() {
                return _this1.props.onChange(option.value);
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: onClick,
                className: (styles_module_default()).option,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: (styles_module_default()).radio,
                        type: "radio",
                        checked: selected,
                        onChange: onClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: option.children
                    })
                ]
            }, index);
        });
    };
    _proto.render = function render() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: this.props.className,
            children: this.renderOptions()
        });
    };
    return RadioComponents;
}(_Component = react.Component);
RadioComponents.propTypes = {
    options: (prop_types_default()).array,
    value: (prop_types_default()).string,
    onChange: (prop_types_default()).func,
    className: (prop_types_default()).string
};


// EXTERNAL MODULE: ./src/components/fields/Stores/index.tsx + 2 modules
var Stores = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Checkbox/index.js
var Checkbox = __webpack_require__(3040);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/DateText/index.js
var DateText = __webpack_require__(56475);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Text/index.js
var Text = __webpack_require__(55672);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Textarea/index.js
var Textarea = __webpack_require__(22052);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
// EXTERNAL MODULE: ./public/images/complaints/clipboard.svg
var clipboard = __webpack_require__(68847);
var clipboard_default = /*#__PURE__*/__webpack_require__.n(clipboard);
// EXTERNAL MODULE: ./public/images/complaints/user.svg
var user = __webpack_require__(84988);
var user_default = /*#__PURE__*/__webpack_require__.n(user);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/helpers/dayjs/index.ts
var dayjs = __webpack_require__(70457);
// EXTERNAL MODULE: ./src/page-components/Complaint/styles.module.css
var Complaint_styles_module = __webpack_require__(57387);
var Complaint_styles_module_default = /*#__PURE__*/__webpack_require__.n(Complaint_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Complaint/Header.tsx




function Header() {
    var complaintDate = (0,dayjs/* default */.Z)().format("DD-MM-YYYY");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "row ".concat((Complaint_styles_module_default()).head),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (Complaint_styles_module_default()).title,
                children: "Libro de Reclamaciones"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Conforme a lo establecido en c\xf3digo de la Protecci\xf3n y Defensa del consumidor contamos con un Libro de Reclamaciones a tu disposici\xf3n para que puedas registrar tu queja o reclamo acerca de alg\xfan pedido o transacci\xf3n realizada"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Hoja de reclamaci\xf3n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Fecha de registro: ",
                    complaintDate
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/page-components/Complaint/LegalInformation/styles.module.css
var LegalInformation_styles_module = __webpack_require__(28445);
var LegalInformation_styles_module_default = /*#__PURE__*/__webpack_require__.n(LegalInformation_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Complaint/LegalInformation/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getStoreInvoiceReceiver($storeId: ID) {\n        store(storeId: $storeId) {\n          invoiceReceiver {\n            legalIdentifier\n            invoiceInformation\n          }\n          address {\n            fullAddress\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function LegalInformation(param) {
    var storeId = param.storeId;
    var store = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,graphql_tag_lib["default"])(_templateObject()),
        variables: {
            storeId: storeId
        },
        fetchPolicy: "cache-first"
    }).store;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LegalInformation_styles_module_default()).legalInformation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "Raz\xf3n Social:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: get_default()(store, "invoiceReceiver.invoiceInformation.legalName", "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "RUC:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: get_default()(store, "invoiceReceiver.legalIdentifier", "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "Direcci\xf3n:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: get_default()(store, "address.fullAddress", "")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/page-components/Complaint/Page/index.tsx
function Page_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Page_templateObject() {
    var data = Page_taggedTemplateLiteral([
        "\n      query getWebsitePageComplaint_cached($websiteId: ID, $path: String) {\n        page: websitePage(websiteId: $websiteId, path: $path) {\n          _id\n        }\n      }\n    "
    ]);
    Page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Page = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7907).then(__webpack_require__.bind(__webpack_require__, 57907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57907)
            ];
        }
    }
});
function OrderPage(props) {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var page = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,graphql_tag_lib["default"])(Page_templateObject()),
        variables: {
            websiteId: websiteId,
            path: "/reclamos"
        },
        partial: true
    }).page;
    if (!page) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
        pageId: page._id
    });
};

;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function recaptcha_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(recaptcha_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(recaptcha_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(recaptcha_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(recaptcha_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
;// CONCATENATED MODULE: ./src/helpers/misc/recaptchaKey.ts

/* harmony default export */ var recaptchaKey = ((0,getEnv/* default */.Z)() === "local" ? "6Ld-G-YZAAAAAPN6YFfAznm-ajgjsLh7TAoJGTHv" : "6LdkTO4ZAAAAAHlcPrJ01VJPrHAWR8_bKd39Ru-w");

;// CONCATENATED MODULE: ./src/page-components/Complaint/recaptcha.tsx




function Recaptcha(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm, {
        sitekey: recaptchaKey,
        onChange: props.onChange
    });
};

;// CONCATENATED MODULE: ./src/page-components/Complaint/Success.tsx




function Success(param) {
    var code = param.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Complaint_styles_module_default()).head,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                children: [
                    "Reclamo N\xba R#",
                    code
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Complaint_styles_module_default()).title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: "\xa1Tu reclamo ha sido ingresado correctamente y te enviamos un correo con el detalle del reclamo!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Un asesor se pondr\xe1 en contacto contigo en un plazo no mayor a 15 d\xedas h\xe1biles."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                to: "/",
                children: "Volver al inicio"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Complaint/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






























function Complaint() {
    var form = (0,useRef/* default */.Z)(null);
    var showMessage = (0,useMessage/* default */.Z)();
    var ref = _slicedToArray((0,useState/* default */.Z)({
        amount: 0,
        storeId: null
    }), 2), doc = ref[0], setDoc = ref[1];
    var ref1 = _slicedToArray((0,useState/* default */.Z)(false), 2), secure = ref1[0], setSecure = ref1[1];
    var ref2 = _slicedToArray((0,useState/* default */.Z)(false), 2), sent = ref2[0], setSent = ref2[1];
    var ref3 = _slicedToArray((0,useState/* default */.Z)(), 2), selectedStoreId = ref3[0], setSelectedStoreId = ref3[1];
    var ref4 = _slicedToArray((0,useState/* default */.Z)(), 2), complaintCode = ref4[0], setComplaintCode = ref4[1];
    var DOCUMENT_TYPES = [
        {
            label: "DNI",
            value: "dni"
        },
        {
            label: "Pasaporte",
            value: "pasaporte"
        }
    ];
    var COMPLAINT_REASON = [
        {
            value: "producto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Complaint_styles_module_default()).infoIcon,
                children: "Producto"
            })
        },
        {
            value: "servicio",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Complaint_styles_module_default()).infoIcon,
                children: "Servicio"
            })
        }
    ];
    var COMPLAINT_TYPE = [
        {
            value: "reclamo",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Reclamo",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                        content: "Disconformidad relacionada a los productos o servicios",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdInfoOutline */.eJU, {
                            size: 20,
                            className: (Complaint_styles_module_default()).infoIcon,
                            color: "#868686"
                        })
                    })
                ]
            })
        },
        {
            value: "queja",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Queja",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                        content: "Disconformidad no relacionada a los productos o servicios",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdInfoOutline */.eJU, {
                            size: 20,
                            className: (Complaint_styles_module_default()).infoIcon,
                            color: "#868686"
                        })
                    })
                ]
            })
        }
    ];
    var onSuccess = function(value) {
        showMessage("Reclamo guardado");
        setComplaintCode(value.code);
        setSent(true);
    };
    var onChange = function(changes) {
        setDoc(_objectSpread({}, changes, {
            storeId: selectedStoreId
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Complaint_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: sent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Success, {
                    code: complaintCode
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoForm/* default */.Z, {
                            mutation: "saveComplaint",
                            ref: form,
                            doc: doc,
                            onChange: onChange,
                            onSuccess: onSuccess,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row ".concat((Complaint_styles_module_default()).marginSection),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (Complaint_styles_module_default()).image,
                                            src: (user_default()),
                                            alt: "user"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Identificaci\xf3n del local"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Complaint_styles_module_default()).marginSection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row ".concat((Complaint_styles_module_default()).marginRow),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-xs-12 col-sm-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                            fieldName: "storeId",
                                                            label: "Seleccionar local",
                                                            type: Stores/* default */.Z,
                                                            multi: false,
                                                            onChange: function(value) {
                                                                setSelectedStoreId(value);
                                                                setDoc(_objectSpread({}, doc, {
                                                                    storeId: value
                                                                }));
                                                                return value;
                                                            }
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-xs-12 col-sm-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformation, {
                                                            storeId: selectedStoreId
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row ".concat((Complaint_styles_module_default()).marginSection),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (Complaint_styles_module_default()).image,
                                            src: (user_default()),
                                            alt: "user"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Identificaci\xf3n del Consumidor Reclamante"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Complaint_styles_module_default()).marginSection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row ".concat((Complaint_styles_module_default()).marginRow),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "fullName",
                                                        type: Text/* default */.Z,
                                                        label: "Nombre Completo"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "address",
                                                        type: Text/* default */.Z,
                                                        label: "Domicilio"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "documentType",
                                                                    label: "Documento Identidad",
                                                                    placeholder: "Selecciona un documento",
                                                                    type: Select/* default */.Z,
                                                                    options: DOCUMENT_TYPES
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "documentNumber",
                                                                    type: Text/* default */.Z,
                                                                    label: "N\xfamero de documento"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "email",
                                                                    label: "Email",
                                                                    type: Text/* default */.Z
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "phone",
                                                                    type: Phone/* default */.Z,
                                                                    label: "Tel\xe9fono Fijo / Celular"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Complaint_styles_module_default()).marginSection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.WithValue, {
                                        children: function(value) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "underAge",
                                                        type: Checkbox/* default */.Z,
                                                        label: "Soy menor de edad"
                                                    }),
                                                    value.underAge ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "tutorName",
                                                                    type: Text/* default */.Z,
                                                                    label: "Nomber Padre/Madre/Tutor"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "tutorAddress",
                                                                    type: Text/* default */.Z,
                                                                    label: "Domicilio"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "tutorEmail",
                                                                    type: Text/* default */.Z,
                                                                    label: "Correo electr\xf3nico"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-xs-12 col-sm-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                                    fieldName: "tutorPhone",
                                                                    type: Phone/* default */.Z,
                                                                    label: "Tel\xe9fono"
                                                                })
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row ".concat((Complaint_styles_module_default()).marginSection, " "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (Complaint_styles_module_default()).image,
                                            src: (clipboard_default()),
                                            alt: "Identificaci\xf3n del bien contratado"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Identificaci\xf3n del bien contratado"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Complaint_styles_module_default()).marginSection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row ".concat((Complaint_styles_module_default()).marginLeft, " ").concat((Complaint_styles_module_default()).marginRow),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                fieldName: "complaintReason",
                                                type: RadioComponents,
                                                options: COMPLAINT_REASON,
                                                className: "row"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "amount",
                                                        type: Money/* default */.Z,
                                                        value: doc.amount,
                                                        label: "Monto Reclamado"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-8",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "description",
                                                        type: Text/* default */.Z,
                                                        label: "Descripci\xf3n"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row ".concat((Complaint_styles_module_default()).marginSection),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (Complaint_styles_module_default()).image,
                                            src: (clipboard_default()),
                                            alt: "detail"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Detalle de Reclamaci\xf3n y Pedido del Consumidor"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row ".concat((Complaint_styles_module_default()).marginSection),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-xs-12 col-sm-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                            fieldName: "issueDate",
                                            label: "Fecha del pedido",
                                            type: DateText/* default */.Z,
                                            placeholder: "DD-MM-AAAA"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Complaint_styles_module_default()).marginSection,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row ".concat((Complaint_styles_module_default()).marginLeft, " ").concat((Complaint_styles_module_default()).marginRow),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                fieldName: "complaintType",
                                                type: RadioComponents,
                                                options: COMPLAINT_TYPE,
                                                className: "row"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "detail",
                                                        type: Textarea/* default */.Z,
                                                        label: "Detalle",
                                                        style: {
                                                            height: "200px"
                                                        },
                                                        autoResize: false,
                                                        placeholder: "Detalles del reclamo o la queja."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-xs-12 col-sm-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                        fieldName: "request",
                                                        type: Textarea/* default */.Z,
                                                        label: "Informaci\xf3n del Pedido",
                                                        style: {
                                                            height: "200px"
                                                        },
                                                        autoResize: false,
                                                        placeholder: "Detalles del pedido, n\xfamero de pedido, plataforma, etc."
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "* La formulaci\xf3n del reclamo no impide acudir a otras v\xedas de soluci\xf3n de controversias ni es requisito previo para interponer una denuncia ante el INDECOPI."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "* El proveedor deber\xe1 dar respuesta al reclamo en un plazo no mayor a quince (15) d\xedas h\xe1biles."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-xs-12 col-sm-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.WithValue, {
                                            children: function(value) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                                    fieldName: "token",
                                                    type: Recaptcha,
                                                    onChange: function(v) {
                                                        !v ? setSecure(false) : setSecure(true);
                                                        value.token = v;
                                                        return v;
                                                    }
                                                });
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: !secure,
                            onClick: function() {
                                return secure && form.current.submit();
                            },
                            children: "Enviar"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Layout/index.tsx
var Layout = __webpack_require__(72700);
// EXTERNAL MODULE: ./src/page-components/NoWebsite/index.tsx
var NoWebsite = __webpack_require__(25442);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/_sites/[mobileOrDesktop]/[hostname]/complaints.tsx






var __N_SSG = true;
function ComplaintsPage(props) {
    var router = (0,next_router.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SsgFallback/* default */.Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWebsite["default"], {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Complaint, {})
    });
};


/***/ }),

/***/ 98751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getClient; }
/* harmony export */ });
/* harmony import */ var _providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40565);

function getClient() {
    var clientName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "main";
    var clients = (0,_providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return clients[clientName];
};


/***/ }),

/***/ 79961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"_1fDaNhCtjd-FpXakwh9Uf3","newOrionLoading":"_16XzDHOt3VBY5SGGpiZ3ZT"};

/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ }),

/***/ 50672:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1beR0zn_HmaurpkUWoqOsy","option":"G8aZZxSfTx1PuD_cuvwNw","radio":"Ks69dwDDAkD8i3TJXhfaS"};

/***/ }),

/***/ 28445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"legalInformation":"_3ZSn0nxtRbjK4viyxJgmIW"};

/***/ }),

/***/ 57387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3DBm0GNSfSX742soQSG7WX orderMainContainer","mobileMarginTop":"_302uBAVC2blbfiZP6Xigop","marginSection":"_3mB6OQdq0XZitafq5TVr0Y","marginRow":"_9hKRcIzJ3Hj-4f8vEG779","marginLeft":"_2wK2Ran8122M5kfTuumZ9y","head":"_2shc5UNsMKjN3FSAk07fzr","title":"_3Ph7wRtxmEHWgk3ECa3aoN","infoIcon":"_3KjOGbh1LLyXGcZBaWnYof","image":"_2xov1DcKc3b7PU1PArOmcI"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 68847:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDE0SDlDOC43MzQ3OCAxNCA4LjQ4MDQzIDE0LjEwNTQgOC4yOTI4OSAxNC4yOTI5QzguMTA1MzYgMTQuNDgwNCA4IDE0LjczNDggOCAxNUM4IDE1LjI2NTIgOC4xMDUzNiAxNS41MTk2IDguMjkyODkgMTUuNzA3MUM4LjQ4MDQzIDE1Ljg5NDYgOC43MzQ3OCAxNiA5IDE2SDE1QzE1LjI2NTIgMTYgMTUuNTE5NiAxNS44OTQ2IDE1LjcwNzEgMTUuNzA3MUMxNS44OTQ2IDE1LjUxOTYgMTYgMTUuMjY1MiAxNiAxNUMxNiAxNC43MzQ4IDE1Ljg5NDYgMTQuNDgwNCAxNS43MDcxIDE0LjI5MjlDMTUuNTE5NiAxNC4xMDU0IDE1LjI2NTIgMTQgMTUgMTRaTTE1IDEwSDExQzEwLjczNDggMTAgMTAuNDgwNCAxMC4xMDU0IDEwLjI5MjkgMTAuMjkyOUMxMC4xMDU0IDEwLjQ4MDQgMTAgMTAuNzM0OCAxMCAxMUMxMCAxMS4yNjUyIDEwLjEwNTQgMTEuNTE5NiAxMC4yOTI5IDExLjcwNzFDMTAuNDgwNCAxMS44OTQ2IDEwLjczNDggMTIgMTEgMTJIMTVDMTUuMjY1MiAxMiAxNS41MTk2IDExLjg5NDYgMTUuNzA3MSAxMS43MDcxQzE1Ljg5NDYgMTEuNTE5NiAxNiAxMS4yNjUyIDE2IDExQzE2IDEwLjczNDggMTUuODk0NiAxMC40ODA0IDE1LjcwNzEgMTAuMjkyOUMxNS41MTk2IDEwLjEwNTQgMTUuMjY1MiAxMCAxNSAxMFpNMTcgNEgxNS44MkMxNS42MTM3IDMuNDE2NDUgMTUuMjMxOSAyLjkxMSAxNC43MjcxIDIuNTUyOTRDMTQuMjIyMiAyLjE5NDg4IDEzLjYxODkgMi4wMDE3NCAxMyAySDExQzEwLjM4MTEgMi4wMDE3NCA5Ljc3NzggMi4xOTQ4OCA5LjI3MjkzIDIuNTUyOTRDOC43NjgwNyAyLjkxMSA4LjM4NjMxIDMuNDE2NDUgOC4xOCA0SDdDNi4yMDQzNSA0IDUuNDQxMjkgNC4zMTYwNyA0Ljg3ODY4IDQuODc4NjhDNC4zMTYwNyA1LjQ0MTI5IDQgNi4yMDQzNSA0IDdWMTlDNCAxOS43OTU2IDQuMzE2MDcgMjAuNTU4NyA0Ljg3ODY4IDIxLjEyMTNDNS40NDEyOSAyMS42ODM5IDYuMjA0MzUgMjIgNyAyMkgxN0MxNy43OTU2IDIyIDE4LjU1ODcgMjEuNjgzOSAxOS4xMjEzIDIxLjEyMTNDMTkuNjgzOSAyMC41NTg3IDIwIDE5Ljc5NTYgMjAgMTlWN0MyMCA2LjIwNDM1IDE5LjY4MzkgNS40NDEyOSAxOS4xMjEzIDQuODc4NjhDMTguNTU4NyA0LjMxNjA3IDE3Ljc5NTYgNCAxNyA0Wk0xMCA1QzEwIDQuNzM0NzggMTAuMTA1NCA0LjQ4MDQzIDEwLjI5MjkgNC4yOTI4OUMxMC40ODA0IDQuMTA1MzYgMTAuNzM0OCA0IDExIDRIMTNDMTMuMjY1MiA0IDEzLjUxOTYgNC4xMDUzNiAxMy43MDcxIDQuMjkyODlDMTMuODk0NiA0LjQ4MDQzIDE0IDQuNzM0NzggMTQgNVY2SDEwVjVaTTE4IDE5QzE4IDE5LjI2NTIgMTcuODk0NiAxOS41MTk2IDE3LjcwNzEgMTkuNzA3MUMxNy41MTk2IDE5Ljg5NDYgMTcuMjY1MiAyMCAxNyAyMEg3QzYuNzM0NzggMjAgNi40ODA0MyAxOS44OTQ2IDYuMjkyODkgMTkuNzA3MUM2LjEwNTM2IDE5LjUxOTYgNiAxOS4yNjUyIDYgMTlWN0M2IDYuNzM0NzggNi4xMDUzNiA2LjQ4MDQzIDYuMjkyODkgNi4yOTI4OUM2LjQ4MDQzIDYuMTA1MzYgNi43MzQ3OCA2IDcgNkg4VjdDOCA3LjI2NTIyIDguMTA1MzYgNy41MTk1NyA4LjI5Mjg5IDcuNzA3MTFDOC40ODA0MyA3Ljg5NDY0IDguNzM0NzggOCA5IDhIMTVDMTUuMjY1MiA4IDE1LjUxOTYgNy44OTQ2NCAxNS43MDcxIDcuNzA3MTFDMTUuODk0NiA3LjUxOTU3IDE2IDcuMjY1MjIgMTYgN1Y2SDE3QzE3LjI2NTIgNiAxNy41MTk2IDYuMTA1MzYgMTcuNzA3MSA2LjI5Mjg5QzE3Ljg5NDYgNi40ODA0MyAxOCA2LjczNDc4IDE4IDdWMTlaIiBmaWxsPSIjMkMwMDAwIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 84988:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,160,3662,5445,5990,6907,4053,4398,1470,4078,1964,3846,6802,4356,7169,191,791,7502,1384,1888,7165,9207,7605,9774,2888,179], function() { return __webpack_exec__(65530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);